import styled from 'styled-components'

const SeoFooter = styled.div`
  padding: 30px 15px;
`

export default SeoFooter
